import React from 'react'
import { CARD_ACTION_COLORS } from '.'

export const Horizontal = ({ onClick, color = CARD_ACTION_COLORS.DEFAULT, children  }) => {
    return (
        <div className="shadow py-2 px-4 mb-2 bg-white rounded" style={{ borderTop:`6px solid ${color}`,  cursor: "pointer" }} onClick={onClick} >
            {children}
        </div>
    )
}